<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <template v-if="data.customMessage">
      <h1 class="cf-title cf-title--1">
        {{ data.customMessage.title }}
      </h1>

      <p class="cf-subtitle cf-subtitle--2">
        {{ data.customMessage.description }}
      </p>
    </template>

    <template v-else>
      <h1 class="cf-title cf-title--1">
        Oops!
      </h1>

      <template v-if="data.capiErrorMessages.length === 0">
        <h3 class="cf-title cf-title--3">
          There was an issue with <span class="no-wrap">your order.</span>
        </h3>

        <p class="cf-subtitle cf-subtitle--2">
          We apologize for the inconvenience. Please try again later.
        </p>
      </template>

      <p
        v-for="message in data.capiErrorMessages"
        :key="message"
        class="cf-subtitle cf-subtitle--2"
      >
        {{ message }}
      </p>
    </template>

    <p class="cf-subtitle cf-subtitle--2">Your cart has been reset.</p>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg"
      @click="$closeModal('orderingError')"
    >
      Okay
    </button>
  </div>
</template>


<script>
  export default {
    name: 'OrderingError',

    props: {
      data: {
        type: Object,
        required: true
      }
    }
  };
</script>
